import { useRef, useEffect } from 'react';

function useInterval(callback, delay) {
  const savedCallback = useRef();
  const interval = useRef();

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    function tick() {
      savedCallback.current();
    }

    if (delay) {
      if (interval.current) {
        clearInterval(interval.current);
      }
      interval.current = setInterval(() => {
        tick();
      }, delay);
      return () => clearInterval(interval.current);
    } else {
      return () => {};
    }
  }, [delay]);
}

export default useInterval;
